import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';

@Component({
  selector: 'app-folder-edit-rights',
  templateUrl: './folder-edit-rights.component.html',
  styleUrls: ['./folder-edit-rights.component.scss']
})
export class FolderEditRightsComponent extends DialogPage implements OnInit {

  public modifyUsers: boolean = true;
  public modifyCompanies: boolean = true;

  // Form data.
  active = 1;
  folderEditRightsForm = new FormGroup({
    usersControl: new FormControl([]),
    companiesControl: new FormControl([]),
    sendEmailControl: new FormControl(false),
  });

  // Datas list.
  public usersList: any[] = [];
  public companiesList: any[] = [];
  public datasUser: any[] = [];
  public datasCompany: any[] = [];

  // Extra data.
  public folderId: string = "";
	public folderName: string = "";
  public buttonText: string;
  public enableAction: boolean;

  constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Editer";
		this.enableAction = true;
	}

  ngOnInit(): void {
    this.put("/api/user-list-usernames", {id: this.folderId}, 
      (response: any) => {
        if (response.DATA == "ERR") {
          switch (response.VALUE) {
            case "UNAUTHORIZED":
              this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
              break;
            case "DATABASE":
              this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
              break;
            default:
              this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
              break;
          }
        } else {
          this.usersList = response.RES;
        }
      },
      (err: any) => {
        // Cannot load the data.
        this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
      }
    );

    this.put("/api/company-list-names", undefined, 
      (response: any) => {
        if (response.DATA == "ERR") {
          switch (response.VALUE) {
            case "UNAUTHORIZED":
              this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
              break;
            case "DATABASE":
              this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
              break;
            default:
              this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
              break;
          }
        } else {
          this.companiesList = response.RES;
        }
      },
      (err: any) => {
        // Cannot load the data.
        this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
      }
    );

    if (this.datasCompany != null) {
      this.folderEditRightsForm.controls["companiesControl"].setValue(this.datasCompany);
      this.folderEditRightsForm.controls["usersControl"].disable();
      this.modifyUsers = false;
    } else if (this.datasUser != null) {
      this.folderEditRightsForm.controls["companiesControl"].disable();
      this.folderEditRightsForm.controls["usersControl"].setValue(this.datasUser);
      this.modifyCompanies = false;
      this.active = 2;
    } else {
      var newData = {
        id: this.folderId
      };
      
      this.put("/api/folder-list-rights", newData, 
        (response: any) => {
          if (response.DATA == "ERR") {
            switch (response.VALUE) {
              case "UNAUTHORIZED":
                this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
                break;
              case "DATABASE":
                this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
                break;
              default:
                this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
                break;
            }
          } else {
            this.folderEditRightsForm.controls["usersControl"].setValue(response.USERSLIST);
            this.folderEditRightsForm.controls["companiesControl"].setValue(response.COMPANIESLIST);
          }
        },
        (err: any) => {
          // Cannot load the data.
          this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
        }
      );
    }
  }

  public setModalOptions(data:any): void {
		// This indicates, it is used inside another window.
    this.folderId = data["id"];
		this.folderName = data["name"];
    this.datasCompany = data["companiesList"] == undefined ? null : data["companiesList"];
    this.datasUser = data["usersList"] == undefined ? null : data["usersList"];
  }

  public save(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
      id: this.folderId,
      users: this.folderEditRightsForm.controls['usersControl'].value,
      companies: this.folderEditRightsForm.controls['companiesControl'].value,
      sendEmail: this.folderEditRightsForm.controls['sendEmailControl'].value,
      modifyUsers: this.modifyUsers,
      modifyCompanies: this.modifyCompanies,
		};

    this.put("/api/folder-edit-rights", newData, 
			(response: any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					// Inserting the new element in the list.
					var newFolder = {
						id: this.folderId,
						usersList: response.USERSLIST,
						companiesList: response.COMPANIESLIST,
					};
					this.modalInstance.dismiss(newFolder);
				}
			},
			(err: any) => {
				this.modalInstance.close(err);
			}
		);
	}

}
